// PAQUETES
import React from "react";
import { Link } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";
// estilos
import '../../estilos/busqueda.css';
// componentes
import CardServicio from '../cardServicio';
import ZonaCargando from '../../paginas/alertas/zonaCargando';
import MapaResultadosBusqueda from './mapaResultadosBusqueda';
import BotonCercaDeMiBusqueda from './botonCercaDeMiBusqueda';

// UI de búsqueda (hero + filtros + chips + resultados + paginación), compartida por
// la página /busqueda (genérica) y /categoria/:categoria (landing por categoría para ads).
// Recibe el estado y handlers de useBusquedaServicios vía la prop `busqueda`.
function PanelBusquedaServicios({
  busqueda,
  usuario,
  cargandoUsuario,
  mostrarSelectorCategoria = true,
  titulo = "Búsqueda",
  subtitulo = "Filtra por categoría, subcategoría, ciudad o palabra clave. Todo desde una sola página.",
  mensajeSinResultados = "Ajusta filtros o haz una búsqueda.",
  imagenesHero,
  onLimpiarFiltros,
  icono,
  textoIntro,
  mostrarBarraConfianza = false,
  mostrarChipsSubcategoria = false,
  mostrarBotonCercaDeMi = false,
}) {
  const {
    palabra, setPalabra,
    ciudad, setCiudad,
    categoria, setCategoria,
    subcategoria, setSubcategoria,
    ordenar, setOrdenar,
    precioMax, setPrecioMax,
    cargando,
    categoriasConfig,
    ciudadesDisponibles,
    resultados,
    error,
    page, setPage,
    total,
    totalPaginas,
    subcategoriasDisponibles,
    imageCate,
    ejecutarBusqueda,
    limpiarFiltros,
    vista, setVista,
    serviciosMapa,
    serviciosDigitales,
    serviciosDomicilio,
    cargandoMapa,
    mapaHabilitado,
    centroMapa,
    mensajeMapa,
    miUbicacion,
    cargarServiciosMapa,
  } = busqueda;

  const cargandoFinal = Boolean(cargandoUsuario) || Boolean(cargando);
  const imageCateHero = Array.isArray(imagenesHero) && imagenesHero.length > 0 ? imagenesHero : imageCate;
  const manejarLimpiar = onLimpiarFiltros || limpiarFiltros;

  // Muestra/actualiza el mapa según el filtro de ciudad actual, cada vez que se dispara una nueva
  // búsqueda (botón "Buscar" o chip de subcategoría) — mismo criterio confirmado y ya aplicado en la
  // app Flutter: el mapa se abre solo apenas la búsqueda incluye una ciudad, sin importar si antes
  // ya estaba abierto o no. Si NO se llama cargarServiciosMapa() acá cuando `vista` recién pasa a
  // "mapa", no hace falta: el useEffect([vista]) del hook ya se encarga de esa primera carga — solo
  // hay que llamarla a mano cuando el mapa YA estaba abierto (ese useEffect no vuelve a dispararse
  // porque `vista` no cambia de valor).
  function refrescarMapaSiAplica(subcategoriaOverride) {
    if (!ciudad) {
      if (vista === "mapa") setVista("lista");
      return;
    }
    if (vista === "mapa") cargarServiciosMapa({ subcategoriaOverride });
    else setVista("mapa");
  }

  function manejarClickSubcategoria(valor) {
    setSubcategoria(valor);
    setPage(1);
    ejecutarBusqueda({ pageOverride: 1, subcategoriaOverride: valor });
    refrescarMapaSiAplica(valor);
  }

  return (
    <div>
      {mostrarBotonCercaDeMi ? <BotonCercaDeMiBusqueda busqueda={busqueda} /> : null}
      {cargandoFinal ? <ZonaCargando /> : null}

      {/* HERO (mismo estilo de Home: fondo full-width + overlay) */}
      <div className="">
        <div className="text-white position-relative estiloHero busqueda-hero" style={{ borderRadius: 0, paddingTop: "1.25rem", paddingBottom: "1.25rem" }} >

          {/* Fondo: Carousel sin controles (solo fondo) */}
          <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 0 }}>
            {Array.isArray(imageCateHero) && imageCateHero.length > 0 ? (
              <Carousel
                className="hero-carousel h-100"
                fade
                controls={false}
                indicators={false}
                interval={6500}
                pause={false}
              >
                {imageCateHero.map((src, idx) => (
                  <Carousel.Item className="h-100" key={src + idx + "-bus"}>
                    <img
                      src={src}
                      className="d-block w-100 h-100"
                      style={{ objectFit: "cover", objectPosition: "50% 50%", height: "100%" }}
                      alt=""
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            ) : (
              <div className="w-100 h-100" style={{ background: "var(--azul-muy-oscuro)" }} />
            )}
          </div>

          {/* Overlay azul */}
          <div
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{
              background:
                "linear-gradient(135deg, rgba(var(--azul-muy-oscuro-rgb), 0.88) 0%, rgba(var(--azul-gradiente-2-rgb), 0.72) 55%, rgba(var(--azul-gradiente-3-rgb), 0.62) 100%)",
              zIndex: 1,
            }}
          />

          {/* Contenido del header */}
          <div className="container position-relative" style={{ zIndex: 2 }}>
            <div className="row justify-content-center">
              <div className="col-12 col-lg-11">

                {/* HEADER / FILTROS */}
                <div className="d-flex flex-column flex-lg-row align-items-lg-end justify-content-between gap-3 mb-3">
                  <div className="d-flex align-items-center gap-3">
                    {icono ? (
                      <div
                        className="rounded-4 d-flex align-items-center justify-content-center flex-shrink-0"
                        style={{ width: 52, height: 52, background: "rgba(var(--blanco-rgb), 0.12)", border: "1px solid rgba(var(--blanco-rgb), 0.20)" }}
                      >
                        <span
                          aria-hidden="true"
                          style={{
                            width: 26,
                            height: 26,
                            display: "inline-block",
                            backgroundColor: "var(--naranja-cta)",
                            WebkitMask: `url(${icono}) center / contain no-repeat`,
                            mask: `url(${icono}) center / contain no-repeat`,
                          }}
                        />
                      </div>
                    ) : null}

                    <div>
                      <h1 className="h3 fw-bold mb-1">{titulo}</h1>
                      <p className="text-white-50 mb-0">{subtitulo}</p>
                    </div>
                  </div>

                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className="btn btn-outline-light"
                      onClick={manejarLimpiar}
                    >
                      Limpiar
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        setPage(1);
                        ejecutarBusqueda({ pageOverride: 1 });
                        refrescarMapaSiAplica();
                      }}
                      disabled={cargando}
                    >
                      {cargando ? "Buscando..." : "Buscar"}
                    </button>
                  </div>
                </div>

                {textoIntro ? (
                  <p className="text-white-50 mb-3" style={{ maxWidth: 720, fontSize: 14.5 }}>{textoIntro}</p>
                ) : null}

                {mostrarBarraConfianza ? (
                  <div className="d-flex flex-wrap gap-2 mb-3">
                    <span className="px-3 py-2 rounded-pill estiloChip">Pagos seguros</span>
                    <span className="px-3 py-2 rounded-pill estiloChip">Soporte</span>
                    <span className="px-3 py-2 rounded-pill estiloChip">Calificaciones reales</span>
                    <span className="px-3 py-2 rounded-pill estiloChip" style={{ backgroundColor: "rgba(var(--rojo-error-rgb), 0.25)", borderColor: "rgba(var(--rojo-error-rgb), 0.5)" }}>
                      <i className="bi bi-lightning-charge-fill me-1" aria-hidden="true"></i>
                      Contrata en 2 horas
                    </span>
                  </div>
                ) : null}

                {mostrarChipsSubcategoria && subcategoriasDisponibles.length > 0 ? (
                  <div className="d-flex flex-wrap gap-2 mb-3">
                    <button
                      type="button"
                      className={`btn btn-sm rounded-pill ${!subcategoria ? "btn-light" : "btn-outline-light"}`}
                      onClick={() => manejarClickSubcategoria(null)}
                    >
                      Todas
                    </button>
                    {subcategoriasDisponibles.map((s) => (
                      <button
                        key={s}
                        type="button"
                        className={`btn btn-sm rounded-pill ${subcategoria === s ? "btn-light" : "btn-outline-light"}`}
                        onClick={() => manejarClickSubcategoria(s)}
                      >
                        {s}
                      </button>
                    ))}
                  </div>
                ) : null}

                <div
                  className="border border-white border-opacity-25 rounded-4 p-3 p-md-4"
                  style={{ borderRadius: 16, background: "rgba(var(--blanco-rgb), 0.08)", backdropFilter: "blur(6px)" }}
                >
                  <div>
                    <div className="row g-2 align-items-end">

                      {/* FILTROS PRINCIPALES */}
                      {mostrarSelectorCategoria ? (
                        <div className="col-12 col-md-4 col-lg-3">
                          <label className="form-label mb-1 text-white">Categoría</label>
                          <select
                            className="form-select"
                            value={categoria || ""}
                            onChange={(e) => {
                              const v = e.target.value || null;
                              setCategoria(v);
                              setSubcategoria(null);
                            }}
                            disabled={cargando && !(categoriasConfig || []).length}
                          >
                            <option value="">Todas</option>
                            {(categoriasConfig || []).map((c) => (
                              <option key={c.categoria} value={c.categoria}>{c.categoria}</option>
                            ))}
                          </select>
                        </div>
                      ) : (
                        <div className="col-12 col-md-6 col-lg-3">
                          <label className="form-label mb-1 text-white">Subcategoría</label>
                          <select
                            className="form-select"
                            value={subcategoria || ""}
                            onChange={(e) => setSubcategoria(e.target.value || null)}
                            disabled={!categoria}
                          >
                            <option value="">Todas</option>
                            {subcategoriasDisponibles.map((s) => (
                              <option key={s} value={s}>{s}</option>
                            ))}
                          </select>
                        </div>
                      )}

                      <div className={mostrarSelectorCategoria ? "col-12 col-md-4 col-lg-3" : "col-12 col-md-6 col-lg-3"}>
                        <label className="form-label mb-1 text-white">Ciudad</label>
                        <select
                          className="form-select"
                          value={ciudad || ""}
                          onChange={(e) => setCiudad(e.target.value || null)}
                        >
                          <option value="">Todas</option>
                          {(ciudadesDisponibles || []).map((c) => (
                            <option key={c} value={c}>{c}</option>
                          ))}
                        </select>
                      </div>

                      <div className={mostrarSelectorCategoria ? "col-12 col-md-4 col-lg-3" : "col-12 col-md-6 col-lg-3"}>
                        <label className="form-label mb-1 text-white">Ordenar por</label>
                        <select
                          className="form-select"
                          value={ordenar || ""}
                          onChange={(e) => setOrdenar(e.target.value || null)}
                        >
                          <option value="">Recomendados</option>
                          <option value="mejor_calificados">Mejor calificados</option>
                          <option value="mas_recientes">Más recientes</option>
                        </select>
                      </div>

                      {mostrarSelectorCategoria ? (
                        <div className="col-12 col-lg-3 d-flex align-items-end justify-content-lg-end gap-2">
                          <button
                            type="button"
                            className="btn btn-outline-light"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFiltrosBusqueda"
                            aria-expanded="false"
                            aria-controls="collapseFiltrosBusqueda"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            Más filtros
                          </button>
                        </div>
                      ) : (
                        <div className="col-12 col-md-6 col-lg-3">
                          <label className="form-label mb-1 text-white">Precio máximo (COP)</label>
                          <input
                            type="number"
                            className="form-control"
                            value={precioMax ?? ""}
                            onChange={(e) => {
                              const v = e.target.value;
                              if (!v) return setPrecioMax(null);
                              const n = Number(v);
                              setPrecioMax(Number.isFinite(n) && n > 0 ? n : null);
                            }}
                            placeholder="Ej: 150000"
                            min={0}
                          />
                        </div>
                      )}

                      {/* FILTROS AVANZADOS (COLLAPSE) — solo en /busqueda, ya que en la página de
                          categoría fija Subcategoría/Precio máximo van siempre visibles arriba. */}
                      {mostrarSelectorCategoria ? (
                        <div className="col-12">
                          <div className="collapse" id="collapseFiltrosBusqueda">
                            <div className="pt-2">
                              <div className="row g-2 align-items-end">

                                <div className="col-12 col-md-6 col-lg-4">
                                  <label className="form-label mb-1 text-white">Subcategoría</label>
                                  <select
                                    className="form-select"
                                    value={subcategoria || ""}
                                    onChange={(e) => setSubcategoria(e.target.value || null)}
                                    disabled={!categoria}
                                  >
                                    <option value="">Todas</option>
                                    {subcategoriasDisponibles.map((s) => (
                                      <option key={s} value={s}>{s}</option>
                                    ))}
                                  </select>
                                </div>

                                <div className="col-12 col-md-6 col-lg-4">
                                  <label className="form-label mb-1 text-white">Precio máximo (COP)</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    value={precioMax ?? ""}
                                    onChange={(e) => {
                                      const v = e.target.value;
                                      if (!v) return setPrecioMax(null);
                                      const n = Number(v);
                                      setPrecioMax(Number.isFinite(n) && n > 0 ? n : null);
                                    }}
                                    placeholder="Ej: 150000"
                                    min={0}
                                  />
                                </div>

                                {/* Palabra clave queda oculta por ahora (ya existe en header global). */}
                                <div className="col-12 col-lg-4 d-none">
                                  <label className="form-label mb-1 text-white">Palabra clave</label>
                                  <input
                                    className="form-control"
                                    value={palabra || ""}
                                    onChange={(e) => setPalabra(e.target.value || null)}
                                    placeholder="Ej: paseo de perros"
                                  />
                                </div>

                              </div>

                              <div className="text-white-50 mt-2" style={{ fontSize: 13 }}>
                                Tip: usa “Más filtros” solo cuando lo necesites. Mantén la búsqueda rápida.
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="col-12 d-none">
                          <input
                            className="form-control"
                            value={palabra || ""}
                            onChange={(e) => setPalabra(e.target.value || null)}
                            placeholder="Ej: paseo de perros"
                          />
                        </div>
                      )}
                    </div>

                    <div className="mt-3 d-flex flex-wrap gap-2">
                      {/* Chips opcionales tipo ecommerce */}
                      {mostrarSelectorCategoria && categoria ? <span className="badge text-bg-light">{categoria}</span> : null}
                      {subcategoria ? <span className="badge text-bg-light">{subcategoria}</span> : null}
                      {ciudad ? <span className="badge text-bg-light">{ciudad}</span> : null}
                      {palabra ? <span className="badge text-bg-light">{palabra}</span> : null}
                      {ordenar ? (
                        <span className="badge text-bg-light">
                          Orden: {ordenar === "mejor_calificados" ? "Mejor calificados" : ordenar === "mas_contratados" ? "Más contratados" : ordenar === "mas_recientes" ? "Más recientes" : "Recomendados"}
                        </span>
                      ) : null}
                      {precioMax ? <span className="badge text-bg-light">Hasta {precioMax.toLocaleString("es-CO")} COP</span> : null}

                      <div className="w-100" />
                      {!cargandoUsuario && !usuario ? (
                        <div className="d-flex flex-wrap gap-2">
                          <Link className="btn btn-outline-light" to="/iniciar-sesion">Iniciar sesión</Link>
                          <Link className="btn btn-light" to="/registrar">Crear cuenta</Link>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CONTENIDO (RESULTADOS) */}
      <div className="container py-4">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-11">

            {/* RESULTADOS */}
            <div className="mt-4">
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
                <h2 className="h5 fw-bold mb-0">Resultados</h2>
                <div className="text-muted" style={{ fontSize: 13 }}>
                  {Number.isFinite(total) ? `${total} encontrados` : (Array.isArray(resultados) ? `${resultados.length} encontrados` : "")}
                </div>
              </div>

              {error ? (
                <div className="alert alert-danger">{error}</div>
              ) : null}

              {vista === "mapa" && ciudad ? (
                <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: 24, overflow: "hidden" }}>
                  <div className="card-body p-3 p-md-4">
                    <div className="d-flex align-items-start justify-content-between flex-wrap gap-2 mb-3">
                      <div>
                        {/* "Cerca de ti" solo si el mapa se resolvió por geolocalización (miUbicacion) —
                            si la ciudad se eligió a mano en el dropdown, puede no ser donde estás de
                            verdad, así que no tendría sentido prometer "cerca de ti". */}
                        <h3 className="h4 fw-bold mb-0">
                          {miUbicacion
                            ? `Servicios cerca de ti${ciudad ? ` en ${ciudad}` : ""}`
                            : `Servicios${ciudad ? ` en la ciudad de ${ciudad}` : ""}`}
                        </h3>
                        <div className="text-body-secondary" style={{ fontSize: 14 }}>
                          {miUbicacion
                            ? "Estos son los proveedores que tienes más cerca."
                            : "Estos son los proveedores disponibles en esta ciudad."}
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => setVista("lista")}
                      >
                        Ocultar mapa
                      </button>
                    </div>

                    <MapaResultadosBusqueda
                      servicios={serviciosMapa}
                      serviciosDigitales={serviciosDigitales}
                      serviciosDomicilio={serviciosDomicilio}
                      centro={centroMapa}
                      miUbicacion={miUbicacion}
                      habilitado={mapaHabilitado}
                      cargando={cargandoMapa}
                      mensaje={mensajeMapa}
                      ciudad={ciudad}
                    />
                  </div>
                </div>
              ) : null}

              {cargando ? (
                <div className="text-muted">Cargando...</div>
              ) : null}

              {!cargando && (!resultados || resultados.length === 0) ? (
                <div className="card border-0 shadow-sm" style={{ borderRadius: 16 }}>
                  <div className="card-body">
                    <div className="fw-semibold">Aún no hay resultados</div>
                    <div className="text-muted" style={{ fontSize: 14 }}>
                      {mensajeSinResultados}
                    </div>
                  </div>
                </div>
              ) : null}

              <div className="row g-3">
                {(resultados || []).map((s, idx) => {
                  const id = s?.idServicio || s?.id || idx;

                  return (
                    <div key={id} className="col-12 col-md-6 col-lg-3">
                      <CardServicio servicio={s} clampDesc={4} textoBoton="Ver servicio" desdeDonde={"busqueda"} />
                    </div>
                  );
                })}
              </div>

              {/* PAGINACIÓN */}
              {!cargando && totalPaginas > 1 ?
              <div className="d-flex justify-content-center mt-4">
                <nav aria-label="Paginación búsqueda">
                  <ul className="pagination mb-0">
                  {/* ANTERIOR */}
                    <li className={`page-item ${page <= 1 ? "disabled" : ""}`}>
                      <button
                        type="button"
                        className="page-link"
                        onClick={() => {
                          const p = Math.max(1, page - 1);
                          setPage(p);
                          ejecutarBusqueda({ pageOverride: p });
                        }}
                        disabled={page <= 1}
                      >
                        Anterior
                      </button>
                    </li>
                    {/* NUMERO PÁGINA */}
                    {Array.from({ length: totalPaginas }).map((_, i) => {
                      const p = i + 1;
                      return (
                        <li key={`pag-${p}`} className={`page-item ${p === page ? "active" : ""}`}>
                          <button
                            type="button"
                            className="page-link"
                            onClick={() => {
                              setPage(p);
                              ejecutarBusqueda({ pageOverride: p });
                            }}
                          >
                            {p}
                          </button>
                        </li>
                      );
                    })}
                    {/* SIGUIENTE */}
                    <li className={`page-item ${page >= totalPaginas ? "disabled" : ""}`}>
                      <button
                        type="button"
                        className="page-link"
                        onClick={() => {
                          const p = Math.min(totalPaginas, page + 1);
                          setPage(p);
                          ejecutarBusqueda({ pageOverride: p });
                        }}
                        disabled={page >= totalPaginas}
                      >
                        Siguiente
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
              : null}

            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default PanelBusquedaServicios;
